import { SVGAttributes } from "react";

export const SlideshowIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" | "regular" }
) => {
  if (props.size === "small") {
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_3378_623)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.626 12.078h-.499a1.993 1.993 0 01-1.377-.55l4.741-4.567a.89.89 0 011.092-.104l1.118.718v2.003l-1.488-.955-3.587 3.455zm.508-5.988c.743 0 1.345-.58 1.345-1.295S7.877 3.5 7.134 3.5c-.742 0-1.344.58-1.344 1.295S6.392 6.09 7.134 6.09z"
            fill="currentColor"
          />
          <rect
            x={-6.001}
            y={2.57}
            width={7.86}
            height={7.86}
            rx={1.5}
            stroke="currentColor"
            strokeWidth={1.5}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.36 2.582A2.25 2.25 0 015.61.332h4.78a2.25 2.25 0 012.25 2.25v7.836a2.25 2.25 0 01-2.25 2.25H5.61a2.25 2.25 0 01-2.25-2.25V2.582zm2.25-.75a.75.75 0 00-.75.75v7.836c0 .414.335.75.75.75h4.78a.75.75 0 00.75-.75V2.582a.75.75 0 00-.75-.75H5.61z"
            fill="currentColor"
          />
          <rect
            x={14.141}
            y={2.57}
            width={7.86}
            height={7.86}
            rx={1.5}
            stroke="currentColor"
            strokeWidth={1.5}
          />
        </g>
        <circle cx={5.5} cy={14.75} r={0.75} fill="currentColor" />
        <circle cx={8} cy={14.75} r={0.75} fill="currentColor" />
        <circle cx={10.5} cy={14.75} r={0.75} fill="currentColor" />
        <defs>
          <clipPath id="clip0_3378_623">
            <path fill="#fff" d="M0 0h16v13H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  } else {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_3378_580)">
          <rect
            x={-10.29}
            y={3.5}
            width={12.86}
            height={12.86}
            rx={2}
            stroke="currentColor"
            strokeWidth={2}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.57 0a3 3 0 00-3 3v13.86a3 3 0 003 3h8.86a3 3 0 003-3V3a3 3 0 00-3-3H7.57zm-1 3a1 1 0 011-1h8.86a1 1 0 011 1v8.73l-1.26-.807a1.397 1.397 0 00-1.71.163l-7.04 6.763a1 1 0 01-.85-.989V3zm4.67 14.86h5.19a1 1 0 001-1v-2.002l-1.839-1.177-4.35 4.179zm1.635-10.158c0 1.117-.943 2.022-2.105 2.022-1.163 0-2.105-.905-2.105-2.022 0-1.117.942-2.022 2.105-2.022 1.162 0 2.105.905 2.105 2.022z"
            fill="currentColor"
          />
          <rect
            x={21.43}
            y={3.5}
            width={12.86}
            height={12.86}
            rx={2}
            stroke="currentColor"
            strokeWidth={2}
          />
        </g>
        <circle cx={8} cy={22.86} r={1} fill="currentColor" />
        <circle cx={12} cy={22.86} r={1} fill="currentColor" />
        <circle cx={16} cy={22.86} r={1} fill="currentColor" />
        <defs>
          <clipPath id="clip0_3378_580">
            <path fill="#fff" d="M0 0h24v19.86H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  }
};
SlideshowIcon.displayName = "SlideshowIcon";
